import { lazy } from "react";
export const AuthAsync = lazy(()=>import("./AuthPage"))